import { Box, Button, Grid, styled, Typography } from "@mui/material";
import ApprovalApi, { ApprovalCancelReceipt, ApprovalStatus } from "api/approval/approval.api";
import { selectMe } from "app/slice/user.slice";
import BtnEditUnderline from "assets/button/BtnEditUnderline";
import { swalCustom } from "component/Alert/Swal";
import ButtonCustom from "component/Button/ButtonCustom";
import HeaderLabel from "component/CardCustom/HeaderLabel";
import InputSecondNewDatePicker from "component/Input/InputSecondNewDatePicker";
import InputTextField from "component/Input/InputTextField";
import Loading from "component/Loading";
import { notiError, notiSuccess } from "component/notifications/notifications";
import AutocompleteSelect from "component/Select/AutocompleteSelect";
import PatientProfileCard from "component/Treatments/PatientProfileCard";
import { colors } from "constants/theme";
import { ApprovalSelectorCustom } from "features/approvel-list/approvel-list";
import MainButton from "new-components/buttons/main-button";
import TextAreaInput from "new-components/inputs/text-area-input";
import AlertModal from "new-components/modal/alert-modal";
import PageModal from "new-components/modal/page-modal";
import { ReactNode, useEffect, useRef, useState } from "react";
import CanvasDraw from "react-canvas-draw";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { routeName } from "routes/routes-name";
import { getClinicInfo, getToken, numberFormat } from "utils/app.utils";
import { dateToView } from "utils/date.utils";
const search = window.location.search;
const params = new URLSearchParams(search);

const StyledSignatureButton = styled(Button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  height: 100px;
  width: 200px;
  border: 1px dashed #bdbdbd;
  padding: 10px;
  color: #828282;
  background-color: transparent;
  &:hover {
    border-color: #808080;
    background-color: #f5f5f5;
  }
  &.Mui-disabled {
    background-color:#F0F0F0;
    border: 1px dashed #bdbdbd;
  }
  @media print {
    border: none !important;
  }
`;


export const SignBox = styled(Box)(({ theme }) => ({
    position: 'relative',
    '> img': {
        position: 'absolute',
        top: 0,
    },
    '.canvas-box > div': {
        margin: 'auto',
        width: '100% !important',
        height: '380px !important',
        border: `1px solid ${colors.lightGray}`,
        borderRadius: '4px',
    },
    '.clear-box': {
        opacity: 1,
        position: 'absolute',
        top: 6,
        right: 6,
        zIndex: 5,
        '.MuiButton-root': {
            padding: '0 12px',
            minWidth: 'unset',
            borderColor: `${colors.themeThirdColor} !important`,
            color: `${colors.themeThirdColor} !important`,
            backgroundColor: `${colors.white} !important`,
            '&:hover': {
                opacity: 1
            }
        }
    },
    '&:hover': {
        '.clear-box': {
            opacity: 1
        }
    }
}));

const initStateErrorMessage = {
    CANCEL_REMARK_STRING_EMPTY: '',
}

export default function OutstandingPayment() {
    const { t } = useTranslation()
    const history = useHistory()
    const location: any = useLocation()
    const branchInfo = getClinicInfo()
    const user = useSelector(selectMe)
    const managerSignatureCanvas: any = useRef(null);
    const [approvalSelect, setApprovalSelect] = useState<ApprovalStatus>(ApprovalStatus.PENDING)
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState<boolean>(false)
    const [approval, setApproval] = useState<boolean>(false)
    const [approvalDisabled, setApprovalDisabled] = useState<boolean>(false)
    const [userApprovel, setUserApprovel] = useState<{ fullname: string, date: string } | undefined>(undefined)
    const [overduePayment, setOverduePayment] = useState<any | null>(null)
    const [dataOut, setDataOut] = useState<any>({})
    const [isOpenPageModal, setIsOpenPageModal] = useState(false)
    const [remarkCancel, setRemarkCancel] = useState('')
    const [configModal, setConfigModal]: any = useState({ modul: '', title: '', message: '', onSubmit: null })
    const [overduePaymentData, setOverduePaymentData] = useState<any | null>(null)
    const [outToken, setOutToken] = useState<boolean>(false)
    const [isCanvasDirty, setIsCanvasDirty] = useState(false)
    const [detailSignature, setDetailSignature]: any = useState({ name: '', who: '', whoEn: '' })
    const [errorMessage, setErrorMessage] = useState<any>({ ...initStateErrorMessage })
    const clearErrorMessage = async () => setErrorMessage(initStateErrorMessage)
    const initialClearDone = useRef(false);
    const token = getToken()

    const handleSetDataApproval = (info: any) => {
        setOverduePaymentData(info);
        setOverduePayment(info);
        setApprovalSelect(info?.status || ApprovalStatus.PENDING);
        setApprovalDisabled(
            info?.status === ApprovalStatus.APPROVED ||
            info?.status === ApprovalStatus.REJECT ||
            info?.status === ApprovalStatus.CANCEL
        );
    };


    const loadPaymentApproval = async () => {
        const newLocation: any = location
        if (newLocation?.search && params.get('id')) {
            setOutToken(true)
            await ApprovalApi.findApprovalOverduePaymentOutToken(String(params.get('id')), String(params.get('token'))).then(({ data }) => {
                const resData = data
                if (resData?.status === ApprovalStatus.APPROVED || resData?.status === ApprovalStatus.REJECT) {
                    setUserApprovel({ fullname: resData?.approvedBy, date: resData?.approvedAt })
                    swalCustom(
                        t(`APPROVELLIST.MESSAGE.IS_APPROVED_TITLE`),
                        t(`APPROVELLIST.MESSAGE.IS_APPROVED_SUB`),
                        () => token === null ? history.push(routeName.login) : history.push(routeName.approvelList),
                        'warning',
                        { cancelButton: { showCancelButton: false }, showCloseButton: false }
                    )
                } else if (resData?.status === ApprovalStatus.CANCEL) {
                    setUserApprovel({ fullname: resData?.approvedBy, date: resData?.approvedAt })
                    swalCustom(
                        t(`APPROVELLIST.MESSAGE.ALERT_CANCEL`),
                        t(`APPROVELLIST.MESSAGE.ALERT_CANCEL_SUB`),
                        () => token === null ? history.push(routeName.login) : history.push(routeName.approvelList),
                        'warning',
                        { cancelButton: { showCancelButton: false }, showCloseButton: false }
                    )
                }
                else {
                    handleSetDataApproval(resData)
                }
            }).catch(() => {
                history.push(routeName.login)
            }).finally(() => setLoading(false))
            return
        }

        if (location?.state?.objData) {
            setOverduePaymentData(location?.state?.objData)
            setApprovalSelect(location?.state?.objData.status)
            setApprovalDisabled(
                location?.state?.objData.status === ApprovalStatus.APPROVED ||
                location?.state?.objData.status === ApprovalStatus.REJECT ||
                location?.state?.objData.status === ApprovalStatus.CANCEL
            );
            await ApprovalApi.findApprovalOverduePayment(location?.state?.objData.approvalItemId).then(({ data }) => {
                setOverduePayment(data)
                setUserApprovel({ fullname: data?.approvedBy, date: data?.approvedAt })
            }).finally(() => setLoading(false))
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        loadPaymentApproval()
    }, [location])


    useEffect(() => {
        if (overduePayment && !initialClearDone.current) {
            if (overduePayment.status === ApprovalStatus.PENDING) {
                setOverduePayment({ ...overduePayment, managerSignature: "" });
                setDataOut({ ...dataOut, signature: { ...dataOut?.signature, managerSignature: '' } });
            }
            initialClearDone.current = true;
        }
    }, [overduePayment])

    const onGoBackApproval = () => {
        history.push(routeName.approvelList)
    }


    const onSubmitOutToken = async () => {
        if (!remarkCancel && approvalSelect !== ApprovalStatus.APPROVED) {
            setErrorMessage({
                CANCEL_REMARK_STRING_EMPTY: !remarkCancel ? t('กรุณาระบุเหตุผลในการไม่อนุมัติ') : ''
            })
            return
        }


        if (String(params.get('id')) && params?.get('token')) {
            setLoading(true)
            const newPayload: any = {
                approveRemark: approvalSelect === ApprovalStatus.REJECT ? remarkCancel : '',
                status: approvalSelect,
                approveToken: String(params.get('token')),
                managerSignature: overduePayment.managerSignature
            }
            await ApprovalApi.approvalLinkOutToken(String(params.get('id')), newPayload).then((res) => {
                setOpenModal(false)
                swalCustom(
                    t('APPROVELLIST.MESSAGE.IS_APPROVED_SUCCESS_TITLE'),
                    `<div style="width:300px" ></div>`,
                    () => token === null ? history.push(routeName.login) : history.push(routeName.approvelList),
                    'warning',
                    { cancelButton: { showCancelButton: false }, showCloseButton: false }
                )
            }).catch((e) => {
                const error = e.response?.data?.message
                const errorMessage = ["IS_APPROVED", "IS_CANCEL"]
                if (errorMessage.includes(error)) {
                    swalCustom(
                        t(`APPROVELLIST.MESSAGE.${error}_TITLE`),
                        t(`APPROVELLIST.MESSAGE.${error}_SUB`),
                        () => token === null ? history.push(routeName.login) : history.push(routeName.approvelList),
                        'warning',
                        { cancelButton: { showCancelButton: false }, showCloseButton: false }
                    )
                } else {
                    notiError(t('APPROVELLIST.MESSAGE.ERROR'))
                }
            }).finally(() => setLoading(false))
        }

    }


    const handleConfirmSubmit = async () => {

        if (!remarkCancel && approvalSelect !== ApprovalStatus.APPROVED) {
            setErrorMessage({
                CANCEL_REMARK_STRING_EMPTY: !remarkCancel ? t('กรุณาระบุเหตุผลในการไม่อนุมัติ') : ''
            })
            return
        }


        const newPayload: ApprovalCancelReceipt = {
            requestReason: overduePaymentData.requestReason,
            requestUserName: overduePaymentData.requestUserName,
            requestUserId: overduePaymentData.requestUserId,
            approveRemark: configModal.modul === ApprovalStatus.REJECT ? remarkCancel : overduePaymentData.approveRemark,
            refId: overduePaymentData.refId,
            branchId: overduePaymentData.branchId,
            status: configModal.modul,
            managerSignature: overduePayment.managerSignature,
        };

        if (newPayload) {
            await ApprovalApi.approvalCancelReceipt(location?.state?.objData.approvalItemId, newPayload).then((res) => {
                notiSuccess(t('APPROVAL.MESSAGE.SUC_CREATE'))
                history.push(routeName.approvelList)
            }).catch((e) => {
                const error = e.response?.data?.message
                const errorMessage = ["IS_APPROVED", "IS_CANCEL"]
                if (errorMessage.includes(error)) {
                    swalCustom(
                        t(`APPROVELLIST.MESSAGE.${error}_TITLE`),
                        t(`APPROVELLIST.MESSAGE.${error}_SUB`),
                        () => history.push(routeName.approvelList),
                        'warning',
                        { cancelButton: { showCancelButton: false }, showCloseButton: false }
                    )
                } else {
                    notiError(t('APPROVELLIST.MESSAGE.ERROR'))
                }
            }).finally(() => {
                setLoading(true);
                setOpenModal(false);
                clearErrorMessage()
            })
        };
    }


    const onSubmitApprovalOutToken = async (status: ApprovalStatus) => {
        setApprovalSelect(status)
        if (!overduePayment.managerSignature) {
            notiError(t('กรุณาลงลายเซ็นผู้จัดการ'))
            setOpenModal(false);
            return
        }
        if (status === 'APPROVED') {
            setConfigModal({ modul: 'APPROVED', title: t('APPROVELLIST.MESSAGE.APPROVAL_SAVE_TITLE'), message: t('APPROVELLIST.MESSAGE.APPROVAL_SAVE_SUB', { approval: t('APPROVELLIST.FILTER.APPROVED') }) })
        } else if (status === 'REJECT') {
            setConfigModal({ modul: 'REJECT', title: 'ไม่อนุมัติคำขอ', message: 'คุณต้องการดำเนินการ "ไม่อนุมัติคำขอนี้"ใช่หรือไม่?' })
        }
        setOpenModal(true)
    }

    const onSubmitApproval = async () => {
        if (!overduePayment.managerSignature) {
            notiError(t('กรุณาลงลายเซ็นผู้จัดการ'))
            setOpenModal(false);
            return
        }

        if (approvalSelect === 'PENDING' || approvalDisabled) {
            history.push(routeName.approvelList)
            return
        } else if (approvalSelect === 'APPROVED') {
            setConfigModal({ modul: 'APPROVED', title: 'ยืนยันการเปลี่ยนสถานะ', message: 'คุณต้องการเปลี่ยนสถานะรายการคำขอ รออนุมัติ เป็น อนุมัติใช่หรือไม่' })
        } else if (approvalSelect === 'REJECT') {
            setConfigModal({ modul: 'REJECT', title: 'ไม่อนุมัติคำขอ', message: 'คุณต้องการดำเนินการ "ไม่อนุมัติคำขอนี้"ใช่หรือไม่?' })
        }
        setOpenModal(true)
    }

    const SignatureButton = ({ type, children, disabled, className, name, subTitle1, subTitle2 }: { type: "doctor" | "patient" | "manager", children: ReactNode, disabled?: boolean, className?: string, name: string, subTitle1: string, subTitle2: string }) => {
        return (
            <StyledSignatureButton
                id="signature-button"
                className={`${className} signature-button`}
                disabled={disabled ?? false}
                variant="outlined"
                onClick={() => {
                    setIsOpenPageModal(true)
                    setDetailSignature({ name: name, who: subTitle1, whoEn: subTitle2 })
                }}
            >{disabled ? <></> : children}</StyledSignatureButton>
        );
    };

    const clearCanvas = (type: 'doctor' | 'patient' | 'manager') => {
        if (type === 'manager' && managerSignatureCanvas.current) {
            managerSignatureCanvas.current.clear()
            managerSignatureCanvas.current.imgSrc = ''
            managerSignatureCanvas.current.resetView()
            setDataOut({ ...dataOut, managerSignature: '', signature: { ...dataOut?.signature, managerSignature: '' } })
            setIsCanvasDirty(false)
        }
    }


    const renderCanvas = (type: 'doctor' | 'patient' | 'manager') => {
        if (type === 'manager') {
            if (managerSignatureCanvas.current) {
                const base64 = managerSignatureCanvas.current.canvasContainer.childNodes[1].toDataURL('image/jpg')
                let base64string: any = `${base64}`.split(',')
                base64string = base64string[base64string.length - 1]
                setDataOut({ ...dataOut, managerSignature: base64string })
            }
        }
    }

    const handleSignature = (type: "submit" | "clear") => {
        if (type === "submit") {
            setOverduePayment({
                ...overduePayment,
                managerSignature: dataOut.managerSignature,
            });
        } else {
            setDataOut({ ...dataOut, managerSignature: '' });
        }
        setIsOpenPageModal(false);
        setIsCanvasDirty(false)
    };

    const clearStampedSignature = () => {
        setOverduePayment({
            ...overduePayment,
            managerSignature: "",
        });
    };



    return (
        <Box overflow={'auto'}>
            <Loading show={loading} type="fullLoading" />
            {overduePayment && (<>
                <AlertModal
                    isOpen={openModal}
                    handleClose={() => {
                        setOpenModal(false)
                        clearErrorMessage()
                    }}
                    type={configModal.modul === 'REJECT' ? 'error' : 'warning'}
                    title={configModal.title}
                    message={configModal.message}
                    onSubmit={{ onClick: outToken ? onSubmitOutToken : handleConfirmSubmit, title: t('BUTTON.SUBMIT') }}
                    onCancel={{
                        onClick: () => {
                            setOpenModal(false)
                            clearErrorMessage()
                        }
                    }}
                >
                    {configModal.modul === 'REJECT' && <Box marginY={2}>
                        <TextAreaInput
                            required
                            fullWidth
                            value={remarkCancel}
                            onChange={(e: any) => setRemarkCancel(e.target.value)}
                            label="ระบุเหตุผลในการไม่อนุมัติ"
                            placeholder="โปรดระบุเหตุผลในการไม่อนุมัติ"
                            helperText={remarkCancel ? '' : errorMessage?.CANCEL_REMARK_STRING_EMPTY || ''} />
                    </Box>}
                </AlertModal>

                {!outToken && <HeaderLabel
                    text={t('MODAL_OUTSTANDINGPAYMENT.TITLE')}
                    componentBtnCustom={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: ' 16px' }}>
                            {!outToken &&
                                (<>
                                    {!loading &&
                                        <Box>
                                            <ApprovalSelectorCustom
                                                approval={approvalSelect}
                                                onChange={setApprovalSelect}
                                                disabled={approvalDisabled}
                                                userApprovel={userApprovel}
                                                onClick={setOpenModal}
                                            />
                                        </Box>
                                    }
                                    <Box sx={{ width: '100px', button: { width: '100%', padding: '6px 16px', filter: 'grayscale(100%) sepia(0%) brightness(35%) contrast(120%)' } }}>
                                        <ButtonCustom
                                            variant={"outlined"}
                                            textButton={t("BUTTON.CANCEL")}
                                            onClick={onGoBackApproval}
                                        />
                                    </Box>
                                    <Box sx={{ width: '100px', button: { width: '100%', padding: '6px 16px', } }}>
                                        <ButtonCustom
                                            textButton={t("BUTTON.SAVE")}
                                            onClick={onSubmitApproval}
                                            disabled={overduePayment.status === ApprovalStatus.APPROVED || overduePayment.status === ApprovalStatus.REJECT || approvalSelect === ApprovalStatus.PENDING || approvalSelect === ApprovalStatus.CANCEL}
                                        />
                                    </Box>
                                </>)
                            }
                        </Box>
                    }
                />
                }
                <Box padding="24px">
                    {outToken && <>
                        <Box sx={{ fontSize: '32px', fontWeight: '600', margin: '0 0 48px 0 ', textAlign: 'center' }}>
                            {t('แจ้งใบขออนุมัติค้างชำระ')}
                        </Box>
                        <Box sx={{ fontSize: '1.5rem', fontWeight: 500, margin: '0 0 16px 0 ', textAlign: 'start' }}>
                            {t('ใบขออนุมัติค้างชำระ')}
                        </Box>
                    </>}
                    {overduePayment?.patientInfo && (
                        <Box marginBottom="24px">
                            <PatientProfileCard patient={overduePayment.patientInfo} type="historyTreatment" />
                        </Box>
                    )}
                    <Box boxShadow={3} borderRadius="8px" width="100%" paddingX="32px" paddingY="24px">
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography fontSize="16px" fontWeight={500}>{t('MODAL_OUTSTANDINGPAYMENT.FORM.HOSPITALNAME')} {branchInfo?.clinicName || overduePayment?.clinicName}</Typography>
                            </Grid>
                            <Grid container spacing={2} marginX={'6px'} marginY={1}>
                                <Grid item xs={12} sm={6} md={3} xl={2}>
                                    <InputSecondNewDatePicker
                                        required
                                        key={'dateStart'}
                                        label={t('MODAL_OUTSTANDINGPAYMENT.FORM.DATESTART')}
                                        value={overduePayment.overdueDateStart ?? ''}
                                        onchange={(e: any) => null}
                                        disableFuture
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3} xl={2}>
                                    <AutocompleteSelect
                                        labelId='doctorId'
                                        inputLabel={t('MODAL_OUTSTANDINGPAYMENT.FORM.DOCTOR')}
                                        required
                                        options={[]}
                                        value={overduePayment.doctorName ?? ''}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3} xl={2}>
                                    <InputSecondNewDatePicker
                                        required
                                        key={'dateStart'}
                                        label={t('วันที่ครบกำหนด')}
                                        value={overduePayment.overdueDate ?? ''}
                                        onchange={(e: any) => null}
                                        disableFuture
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3} xl={6}>
                                    <Box className={`pl-12-xl`} sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                        <Box>
                                            {t('MODAL_OUTSTANDINGPAYMENT.FORM.PRICE')}<span style={{ color: colors.statusInactive }}>*</span>
                                        </Box>
                                        <Box>
                                            <InputTextField
                                                name={'price'}
                                                value={overduePayment.overdueTotal ?? ''}
                                                disabled
                                            />
                                        </Box>
                                        <Box>
                                            {t('CURRENCY_CHANGE.TH')}
                                        </Box>
                                    </Box >
                                </Grid>

                            </Grid>
                            <Grid item xs={12} lg={12}>
                                <Box
                                    sx={{
                                        backgroundColor: "#F0F0F0",
                                        padding: "20px",
                                        borderRadius: "10px",
                                        marginTop: "20px",
                                        color: "#000",
                                    }}
                                >
                                    <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} marginBottom={2}>
                                        <Typography fontSize={'16px'} fontWeight={600}>ข้าพเจ้า {overduePayment.patientName}</Typography>
                                        <Typography fontSize={'16px'} fontWeight={600}>CN: {overduePayment.cnNumber}</Typography>
                                    </Box>
                                    <Typography>
                                        {t(`MODAL_OUTSTANDINGPAYMENT.FORM.DETAIL_EXAM`,
                                            {
                                                // hospitalName: branchInfo?.hospitalName,
                                                branchName: overduePayment?.branchName,
                                                dateStart: overduePayment?.overdueDateStart ? dateToView(overduePayment.overdueDateStart) : '-',
                                                dateEnd: overduePayment?.overdueDate ? dateToView(overduePayment.overdueDate) : '-',
                                                price: overduePayment?.overdueTotal ? numberFormat(overduePayment.overdueTotal || 0, 2) : '0.00',
                                                paymentId: dataOut?.paymentNumber || '-'
                                            })}
                                    </Typography>
                                </Box>

                                <Grid container sx={{ marginTop: "20px" }} spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: 'flex-start' } }}>
                                            <Box
                                                sx={{
                                                    border: "1px solid #E0E0E0",
                                                    borderRadius: "6px",
                                                    padding: "10px",
                                                    height: "100px",
                                                    width: "200px",
                                                    pointerEvents: "none",
                                                }}
                                            >
                                                <Box display={'flex'} justifyContent={'center'}>
                                                    <img src={`data:image/png;base64,${overduePayment.patientSignature}`} style={{ width: '190px', height: '90px', objectFit: 'contain' }} alt="" />
                                                </Box>
                                            </Box>
                                            <Box>
                                                <Typography sx={{ textAlign: "center", marginTop: "10px" }}>
                                                    {overduePayment.patientName}
                                                </Typography>
                                                <Typography sx={{ textAlign: "center", color: "#828282" }}>
                                                    {t('MODAL_TREATMENT_CONSENT.SIGN.PATIENT')}
                                                </Typography>
                                                <Typography sx={{ textAlign: "center", color: "#828282" }}>
                                                    {`Patient's Signature`}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>


                                    <Grid item xs={12} md={6}>
                                        <Grid container spacing={2} sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}>
                                            <Grid item xs={12} sm={6} md="auto">
                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <Box
                                                        sx={{
                                                            border: "1px solid #E0E0E0",
                                                            borderRadius: "6px",
                                                            padding: "10px",
                                                            height: "100px",
                                                            width: "200px",
                                                            pointerEvents: "none",
                                                        }}
                                                    >
                                                        <Box display={'flex'} justifyContent={'center'}>
                                                            <img src={`data:image/png;base64,${overduePayment.doctorSignature}`} style={{ width: '190px', height: '90px', objectFit: 'contain' }} alt="" />
                                                        </Box>
                                                    </Box>
                                                    <Typography sx={{ textAlign: "center", marginTop: "10px" }}>
                                                        {overduePayment.doctorName}
                                                    </Typography>
                                                    <Typography sx={{ textAlign: "center", color: "#828282" }}>
                                                        แพทย์ประจำคลินิก
                                                    </Typography>
                                                    <Typography sx={{ textAlign: "center", color: "#828282" }}>
                                                        {t('PDF_INVOICE.PDF.DOCTOR_SIGNATURE_EN')}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            {/* ลายเซ็นพนักงานการเงิน (ถ้ามี) */}
                                            {overduePayment.financeSignature && (
                                                <Grid item xs={12} sm={6} md="auto">
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <Box
                                                            sx={{
                                                                border: "1px solid #E0E0E0",
                                                                borderRadius: "6px",
                                                                padding: "10px",
                                                                height: "100px",
                                                                width: "200px",
                                                                pointerEvents: "none",
                                                            }}
                                                        >
                                                            <Box display={'flex'} justifyContent={'center'}>
                                                                <img src={`data:image/png;base64,${overduePayment.financeSignature}`} style={{ width: '190px', height: '90px', objectFit: 'contain' }} alt="" />
                                                            </Box>
                                                        </Box>
                                                        <Typography sx={{ textAlign: "center", marginTop: "10px" }}>
                                                            {overduePayment.financeUserName || '-'}
                                                        </Typography>
                                                        <Typography sx={{ textAlign: "center", color: "#828282" }}>
                                                            {t('MODAL_OUTSTANDINGPAYMENT.FORM.FINANCE')}
                                                        </Typography>
                                                        <Typography sx={{ textAlign: "center", color: "#828282" }}>
                                                            Finance Staff
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            )}

                                            <Grid item xs={12} sm={6} md="auto">
                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    {overduePayment.managerSignature ? (
                                                        <Box sx={{ position: 'relative' }}>
                                                            <Box
                                                                sx={{
                                                                    border: "1px solid #E0E0E0",
                                                                    borderRadius: "6px",
                                                                    padding: "10px",
                                                                    height: "100px",
                                                                    width: "200px",
                                                                }}
                                                            >
                                                                <Box display={'flex'} justifyContent={'center'}>
                                                                    <img src={`data:image/png;base64,${overduePayment.managerSignature}`} style={{ width: '190px', height: '90px' }} alt="" />
                                                                </Box>
                                                            </Box>
                                                            <Box sx={{ position: 'absolute', top: 5, right: 3, zIndex: 1 }}>
                                                                <MainButton
                                                                    variant={'outlined'}
                                                                    title={t('MODAL_TREATMENT_CONSENT.BUTTON.CLEAR_CANVAS')}
                                                                    type='danger'
                                                                    onClick={clearStampedSignature}
                                                                    disabled={overduePayment.status === ApprovalStatus.APPROVED || overduePayment.status === ApprovalStatus.REJECT || overduePayment.status === ApprovalStatus.CANCEL}
                                                                    style={{
                                                                        fontSize: '12px',
                                                                        minWidth: 'auto',
                                                                        backgroundColor: 'white',
                                                                        height: '25px'
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Box>
                                                    ) : (
                                                        <SignatureButton type='manager' disabled={overduePayment.status === ApprovalStatus.APPROVED || overduePayment.status === ApprovalStatus.REJECT || overduePayment.status === ApprovalStatus.CANCEL} name={overduePayment?.managerName || user?.fullname} subTitle1={'ผู้จัดการ'} subTitle2={'Manager'}>
                                                            <BtnEditUnderline color={'#808080'} width='20' height='20' />
                                                            <Typography sx={{ fontWeight: '500', fontSize: '16px' }}>{t(`PDF_INVOICE.PDF.CLICK_SIGNATURE`)}</Typography>
                                                        </SignatureButton>
                                                    )}
                                                    <Typography sx={{ textAlign: "center", marginTop: "10px" }}>
                                                        {overduePayment?.managerName || user?.fullname || overduePayment?.approveName || "..........................................."}
                                                    </Typography>
                                                    <Typography sx={{ textAlign: "center", color: "#828282" }}>
                                                        ผู้จัดการ
                                                    </Typography>
                                                    <Typography sx={{ textAlign: "center", color: "#828282" }}>
                                                        Manager
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>


                    {outToken &&
                        <Box sx={{
                            marginTop: '24px',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '12px',
                            width: '100%'
                        }}>
                            <Box sx={{ width: '100px' }}>
                                <ButtonCustom
                                    textButton={t('APPROVELLIST.FILTER.REJECT')}
                                    variant={"outlined"}
                                    mode={'del'}
                                    btnStyle={{ width: "100%" }}
                                    onClick={() => onSubmitApprovalOutToken(ApprovalStatus.REJECT)}
                                />
                            </Box>
                            <Box sx={{ width: '100px' }}>
                                <ButtonCustom
                                    textButton={t('APPROVELLIST.FILTER.APPROVED')}
                                    btnStyle={{ width: "100%" }}
                                    onClick={() => onSubmitApprovalOutToken(ApprovalStatus.APPROVED)}
                                />
                            </Box>
                        </Box>
                    }
                </Box>

                {(overduePayment?.status === ApprovalStatus.REJECT) && (
                    <Box fontSize="16px" fontWeight={400} gap="8px" paddingTop="24px" paddingX={"24px"}>
                        <Box display="flex" flexDirection="row" alignItems="center" gap="8px">
                            <Typography color="#FB5252">{t('เหตุผลในการไม่อนุมัติ')} :</Typography>
                            <Typography> {overduePayment?.approveRemark}</Typography>
                        </Box>
                        <Box display="flex" flexDirection="row" alignItems="center" gap="8px">
                            <Typography color="#FB5252">{t('ผู่ไม่อนุมัติ')} :</Typography>
                            <Typography>{overduePayment?.approvedBy}
                            </Typography>
                        </Box>
                    </Box>
                )}
                <PageModal
                    isOpen={isOpenPageModal}
                    size={'S'}
                    title={t('PDF_INVOICE.PDF.SIGNATURE')}
                    handleClose={() => handleSignature("clear")}
                    onSubmit={{ onClick: () => handleSignature("submit"), disabled: !isCanvasDirty }}
                    onCancel={{ onClick: () => handleSignature("clear") }}
                    overflow
                ><Box>
                        <Box className={`signatureWrap-box w-100 mt-3 mt-md-0`}>
                            <Box>
                                <SignBox >
                                    <Box className={`clear-box `}>
                                        <ButtonCustom variant={'outlined'} textButton={t('MODAL_TREATMENT_CONSENT.BUTTON.CLEAR_CANVAS')} onClick={() => clearCanvas('manager')} />
                                    </Box>
                                    {dataOut?.signature?.managerSignature && (
                                        <img src={`data:image/png;base64,${dataOut?.signature?.managerSignature}`} className="w-100 h-100" alt="" />
                                    )}
                                    <Box className="canvas-box" onMouseDown={() => setIsCanvasDirty(true)} onTouchStart={() => setIsCanvasDirty(true)}>
                                        <CanvasDraw
                                            hideGrid
                                            hideInterface
                                            brushRadius={2}
                                            lazyRadius={2}
                                            disabled={dataOut?.signature?.managerSignature}
                                            brushColor={colors.black}
                                            // imgSrc={dataOut?.signature?.managerSignature ? `data:image/png;base64,${dataOut?.signature?.managerSignature}` : ''}
                                            ref={managerSignatureCanvas}
                                            onChange={() => renderCanvas('manager')} />
                                    </Box>
                                </SignBox>
                            </Box>
                            <Box className='text-center mt-2'>
                                <Typography sx={{ fontWeight: 500 }}> {overduePayment?.managerName || user?.fullname || overduePayment?.approveName || "..........................................."}  </Typography>
                                <Typography className='d-none d-md-block' sx={{ fontSize: 14 }}>{t('MODAL_OUTSTANDINGPAYMENT.FORM.MANAGER')}</Typography>
                                <Typography className='d-none d-md-block' sx={{ fontSize: 14 }}>Manager</Typography>
                            </Box>
                        </Box>
                    </Box>
                </PageModal>
            </>)}
        </Box>
    )
}
